import styled from "styled-components"
import { respondTo } from "theme/base/Mixins"

const CustomStyled = styled.div`
  .box-attachment-files-vip {
    background: #ECEDF1;
    padding: 1rem;
    
    .title {
      font-size: 1.2rem;
      text-align: center;
    }

    .options {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-top: 1rem;

      & > div {
        flex: 1 1 0%;
      }
    }

    .text-alert {
      color: #FD3A4A;
      margin-top: 1.5rem;
      text-align: center;
    }
  }

  &.header-title {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 0.3rem 0;
    background: #ECEDF1;

    .title-order {
      display: flex;
      width: 100%;
      justify-content: center;
      color: #3E405B;
      font-size: 1rem;
      font-weight: bold;
    }

    .title-status {
      display: flex;
      width: 100%;
      padding: 0 7px;
      gap: 8px;

      & .pending-label {
        color: #ffffff;
        background: #ED1E79;
        font-size: 1.2rem;
        font-weight: 600;
        padding: 0 8px;
        margin-left: auto;

        &.close {
          background: #666666;
        }
      }

      & .label-plan-zero {
        background: linear-gradient(90deg, #5a0070, #8a00a8);
        color: #ffffff;
        font-size: 16x;
        font-weight: 600;
        padding: 4px 12px;
        border-radius: 6px;
        text-transform: uppercase;
        letter-spacing: 0.6px;
      }

      & .has-debt-label {
        color: #ffffff;
        background: #ED1E79;
        font-size: 1.2rem;
        font-weight: 600;
        padding: 0 8px;
      }
    }
  }

  ${respondTo.sm`
    .box-attachment-files-vip {
      .options {
        flex-direction: row;
      }
    }
  `}
`

export default CustomStyled